import { Paper as MuiPaper, styled } from '@mui/material';
import type { PaperProps as MuiPaperProps } from '@mui/material';
import ornamentsShapes1Url from '@resources/img/theme/dialog/ornaments-shapes-1.svg?url';
import ornamentsShapes2Url from '@resources/img/theme/dialog/ornaments-shapes-2.svg?url';
import ornamentsShapes3Url from '@resources/img/theme/dialog/ornaments-shapes-3.svg?url';
import ornamentsShapes3TopUrl from '@resources/img/theme/dialog/ornaments-shapes-3-top.svg?url';


const StyledPaper = styled(MuiPaper)({
	'&.ornaments-shapes-1': {
		backgroundImage: 'url('+ornamentsShapes1Url+')',
		backgroundSize: '100%',
		backgroundPosition: 'center top',
		backgroundRepeat: 'no-repeat',
	},

	'&.ornaments-shapes-2': {
		backgroundImage: 'url('+ornamentsShapes2Url+')',
		backgroundPosition: 'right top',
		backgroundRepeat: 'no-repeat',
	},

	'&.ornaments-shapes-3': {
		backgroundImage: 'url('+ornamentsShapes3Url+')',
		backgroundPosition: 'bottom',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain',
	},

	'&.ornaments-shapes-3-top': {
		backgroundImage: 'url('+ornamentsShapes3TopUrl+')',
		backgroundPosition: 'top',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain',
	},
	
	'@media (max-width: 760px)': {
		'&:not(.MuiDialog-paperWidthXs):not(.MuiDialog-paperFullScreen)': {
			margin: '16px 16px 0',
			width: 'calc(100% - 32px)',
			alignSelf: 'flex-end',
			borderBottomLeftRadius: '0',
			borderBottomRightRadius: '0',
		},
	},

	'&.MuiDialog-paperFullScreen': {
		borderRadius: 0,
		height: '100%',
		margin: 0,
		maxHeight: 'none',
		maxWidth: '100%',
		width: '100%',
	}
});

export type DialogPaperOrnaments = 'shapes-1'|'shapes-2'|'shapes-3'|'shapes-3-top'

type Props = MuiPaperProps & {
	ornaments?: DialogPaperOrnaments
}

export default function DialogPaper(props: Props) {
	const { className, ...otherProps } = props;

    return <StyledPaper
		{...otherProps}
		className={[
			className,
			'notranslate',
			props.ornaments ? 'ornaments-'+props.ornaments : null,
		].filter(Boolean).join(' ')}
		translate="no"
	/>
}
